import { useEffect, useState } from 'react';
import { useMyCalenderContext } from '../../../../pages/my-calendar/context';
import ClientFormFilter from './form'
import { labelValueType, labelValueStringType } from '../../../client/all-clients/types';
import { getClientTypes, getClientContacts, getClientsById } from '../helper';

const ClientFilter = () => {
    const [clientValues, setClientValues] = useState<labelValueType[] | null>(null);
    const [fk_client, setFkClient] = useState<labelValueStringType[] | null>(null);
    const [client_type, setClientType] = useState<labelValueStringType[] | null>(null);
    const { filters } = useMyCalenderContext();

    useEffect(() => {
        getClientContacts(filters.sidebarFilters.client_contacts, setClientValues);
        getClientTypes(filters.sidebarFilters.client_type, setClientType);
        getClientsById(filters.sidebarFilters.fk_client, setFkClient);
    }, [filters.sidebarFilters.client_type, filters.sidebarFilters.client_contacts, filters.sidebarFilters.fk_client]);

    return (
        <>
            {
                clientValues && fk_client && client_type &&
                <ClientFormFilter clientValues={clientValues} fk_client={fk_client} client_type={client_type} />
            }
        </>
    )
}

export default ClientFilter